// notifyBridge.js
//
// TEMPORARY — delete this file and its import in POSApp.js once the main
// backend pushes to the hub itself.
//
// Saves go to the main backend, which does not know the hub yet. So after a
// save comes back successful, this tells the realtime server which orders
// changed, and the server passes that on to the other tablets as kotChanged.
//
// It watches the shared axios instance instead of being called from each
// screen, so no save site had to change and nothing is left behind in the
// screens when this goes away. Two saves are watched:
//   UpdateDynamicData?model=Restaurant_Action_Update   a status change; the
//       orders are the requestid of each row in the body
//   Insert/UpdateDynamicData?model=requestSave         an order saved from a
//       POS screen; the order is the request id the save returned
//
// It only ever listens: the response is handed back untouched, and a notify
// that fails is dropped — it must never fail or delay a save.

import axios from '../../axios-url';
import { Companyid } from '../../shared/Config';
import { REALTIME_URL } from './posRealtime';

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
const isGuid = (v) => typeof v === 'string' && GUID.test(v) && v !== EMPTY_GUID;

// The body is { Key: "<json>" }, itself sent either as an object or as a string.
const readKey = (data) => {
    const body = typeof data === 'string' ? JSON.parse(data) : data;
    const k = body && body.Key;
    return typeof k === 'string' ? JSON.parse(k) : k;
};

const notify = (requestIds, branchId) => {
    const ids = Array.from(new Set(requestIds.filter(isGuid).map((id) => id.toLowerCase())));
    if (ids.length === 0) return;
    const body = { companyId: Companyid, requestIds: ids };
    if (isGuid(branchId)) body.branchId = branchId;
    fetch(REALTIME_URL + '/api/notify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    }).catch(() => {});
};

const inspect = (response) => {
    const cfg = response.config || {};
    if (response.status !== 200 || String(cfg.method).toLowerCase() !== 'post') return;
    const url = String(cfg.url || '');

    if (/model=Restaurant_Action_Update/i.test(url)) {
        const rows = readKey(cfg.data);
        if (!Array.isArray(rows)) return;
        // One branch for every row: tell that branch. Otherwise the whole company.
        const branches = Array.from(new Set(rows.map((r) => r && r.branch).filter(isGuid).map((b) => b.toLowerCase())));
        const oneBranch = branches.length === 1 && rows.every((r) => r && isGuid(r.branch));
        notify(rows.map((r) => r && (r.requestid || r.requestId || r.RequestID)), oneBranch ? branches[0] : null);
        return;
    }

    // requestSave is also how the rest of the app saves its own requests; only
    // an order saved from a POS screen concerns the action list.
    if (/model=requestSave/i.test(url) && window.location.href.indexOf('/pos') !== -1) {
        const data = readKey(cfg.data);
        const returned = response.data && response.data.requestId;
        notify([isGuid(returned) ? returned : (data && data.RequestID)], null);
    }
};

if (REALTIME_URL && !axios.__posNotifyBridge) {
    axios.__posNotifyBridge = true;
    axios.interceptors.response.use((response) => {
        try { inspect(response); } catch (e) { /* never let this touch the save */ }
        return response;
    });
}
